export const LOCALES = ['da', 'en']

export const getPreferredLocale = (preferredLanguages) => {
  const browserLanguages =
    typeof navigator !== 'undefined' ? navigator.languages : undefined
  const browserLanguage =
    typeof navigator !== 'undefined' ? navigator.language : undefined
  const languages =
    preferredLanguages ||
    (browserLanguages && browserLanguages.length > 0
      ? browserLanguages
      : browserLanguage) ||
    []
  const preferredLanguage = Array.isArray(languages) ? languages[0] : languages
  const locale = preferredLanguage && preferredLanguage.split('-')[0]

  return LOCALES.includes(locale) ? locale : 'en'
}

export const DEFAULT_LOCALE = getPreferredLocale()

// English is the only prefixed locale; unprefixed paths are Danish.
export const detectLocaleFromPath = (pathname = '/', defaultLocale = 'da') =>
  pathname === '/en' || pathname.startsWith('/en/') ? 'en' : defaultLocale

export const stripLocalePrefix = (pathname = '/') => {
  if (pathname === '/en') return '/'
  if (pathname.startsWith('/en/')) return pathname.slice(3)
  return pathname
}

// Prefixes an absolute app path with the locale prefix when needed.
export const localePath = (path = '/', locale = DEFAULT_LOCALE) => {
  if (locale !== 'en') return path
  return path === '/' ? '/en' : `/en${path}`
}

// Prefixes an absolute app path with the locale of the current URL. Reads
// window.location directly so it is safe to call during render, before the
// i18next language has caught up with a navigation.
export const localizePath = (path = '/') =>
  localePath(path, detectLocaleFromPath(window.location.pathname))
